// extracted by mini-css-extract-plugin
export default {"formHeading":"VG-z","form":"WG-z","submitBtn":"XG-z","disabled":"YG-z","input":"ZG-z","error":"_G-z","submitMsg":"aH-z","signIn":"bH-z"};